const CENTIMETERS_PER_INCH = 2.54;

export function cmToIn(cm: number) {
  return cm / CENTIMETERS_PER_INCH;
}

export function cmToPx(cm: number, dpi: number) {
  const inches = cmToIn(cm);
  return inches * dpi;
}

export enum Format {
  CM, // centimeters
  MM, // millimeters
  IN, // inches
  PX300DPI, // px at 300di
}

function formatSize(width: number, height: number, unit: string) {
  // use 3 digits of precision (e.g. 3.46 or 34.6 or 346)
  // unless number is over 1000 (i.e. it has more than 3 digits to the left of the decimal) in which case we just trim off any decimals
  const widthStr = width > 1000 ? width.toFixed(0) : width.toPrecision(3);
  const heightStr = height > 1000 ? height.toFixed(0) : height.toPrecision(3);

  return `${widthStr} x ${heightStr} ${unit}`;
}

export function getFormattedSize(widthCm: number, heightCm: number, format: Format) {
  switch (format) {
    case Format.CM:
      return formatSize(widthCm, heightCm, 'cm');
    case Format.MM:
      return formatSize(widthCm * 10, heightCm * 10, 'mm');
    case Format.IN:
      return formatSize(cmToIn(widthCm), cmToIn(heightCm), 'in');
    case Format.PX300DPI:
      return formatSize(cmToPx(widthCm, 300), cmToPx(heightCm, 300), 'px');
  }
}

/**
 * Returns a formatted size-string that's appropriate for the given locale
 * @param widthCm - width in centimeters
 * @param heightCm - height in centimeters
 * @param locale - locale (e.g. "en-us")
 */
export function getLocaleDefaultSize(widthCm: number, heightCm: number, locale: string) {
  let format = Format.MM;
  switch (locale) {
    case 'en-us':
      format = Format.IN;
      break;
    case 'en-gb':
      format = Format.MM;
      break;
    default:
      format = Format.MM;
  }

  return getFormattedSize(widthCm, heightCm, format);
}
